import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'kiene-select-befund-kategorie-dialog',
    templateUrl: './select-befund-kategorie-dialog.component.html',
    styleUrls: ['./select-befund-kategorie-dialog.component.scss'],
})
export class SelectBefundKategorieDialogComponent implements OnInit {
    categories = ['E', 'S', 'B', 'M', 'PF', 'FB'];
    selectedCategory = undefined;

    title = 'Befund erstellen';
    text = 'Bitte erst eine Kategorie wählen, um einen neuen Befund zu erstellen!';
    buttonText = 'Erstellen';

    constructor(
        public dialogRef: MatDialogRef<SelectBefundKategorieDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {}

    ngOnInit(): void {
        if (this.data) {
            if (this.data.title) {
                this.title = this.data.title;
            }
            if (this.data.text) {
                this.text = this.data.text;
            }
            if (this.data.buttonText) {
                this.buttonText = this.data.buttonText;
            }
        }
    }
}
